import React, { useState, useEffect , FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Addresses } from "utils/Addresses";
import { URL_Route } from "urlRouts";
import SiteTexts from "utils/Texts";
import { DashboardMenu } from "utils/DashboardMenu";
import CustomModal from "components/Modal/CustomModal";
import TextInput from "components/Input/TextInput";
import { Labels } from "utils/Labels";
import { ValidationErrorMessages } from "utils/Error";
import { Axios_Route } from "API/AxiosRouts";
import Axios, { baseURL } from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { notify, ToastType } from "utils/Toast";
import { useDispatch } from "react-redux";
import { setRoleAction, setNameAction, setProfilePictureAction } from "ReduxSaga/actions/UserActions";
import { useSelector } from "react-redux";


interface ChangePassword {
  oldPasswordError: string | null;
  newPasswordError: string | null;
  confirmPasswordError: string | null;
}

interface Props {
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SideMenuMobile: React.FC<Props> = ({
  isDrawerOpen,
  setIsDrawerOpen,
}) => {
  const SiteText = SiteTexts();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [repeatNewPassword, setRepeatNewPassword] = useState<string>("");
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [allowToSubmit, setAllowToSubmit] = useState<boolean>(true);
  const [urlPathname, setUrlPathname] = useState<string>(
    window.location.pathname
  );
  const [error, setError] = useState<ChangePassword>({
    oldPasswordError: null,
    newPasswordError: null,
    confirmPasswordError: null,
  });
  const userStates = useSelector((state: any) => state.userState);
  const dispatch = useDispatch();

  useEffect(() => {
    Axios(AxiosMethodEnum.get, Axios_Route.USER_INFO).then(
      ({ response, success }) => {
        setAllowToSubmit(true);
        if (success) {
          dispatch(setNameAction(response.fullName));
          dispatch(setRoleAction(response.roleName));
          dispatch(setProfilePictureAction(response.imageUrl));
        }
      }
    );
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    setUrlPathname(window.location.pathname);
  }, [navigate]);

  useEffect(() => {
    if (showErrors) {
      errorHandling();
    }
  }, [oldPassword, newPassword, repeatNewPassword]);

  const errorHandling = () => {
    let AllowToContinue = true;

    if (oldPassword.length === 0) {
      error.oldPasswordError = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.oldPasswordError = null;
    }

    if (newPassword.length === 0) {
      error.newPasswordError = ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.newPasswordError = null;
    }

    if (repeatNewPassword.length === 0) {
      error.confirmPasswordError =
        ValidationErrorMessages.ERRORS.FIELD_REQUIRED;
      AllowToContinue = false;
    } else {
      error.confirmPasswordError = null;
    }

    if (repeatNewPassword !== newPassword) {
      error.confirmPasswordError =
        ValidationErrorMessages.ERRORS.PASSWORD_AND_CONFIRM_PASSWORD_BE_THE_SAME;
      AllowToContinue = false;
    } else {
      error.confirmPasswordError = null;
    }
    setError({ ...error });

    return AllowToContinue;
  };

  const ChangePassword = (e: FormEvent) => {
    e.preventDefault();

    setShowErrors(true);
    let AllowToContinue = errorHandling();

    if (AllowToContinue && allowToSubmit) {
      setAllowToSubmit(false);
      const ResetPassword = {
        confirmPassword: repeatNewPassword,
        newPassword: newPassword,
        oldPassword: oldPassword,
      };
      Axios(AxiosMethodEnum.post,Axios_Route.CHANGE_PASSWORD, ResetPassword).then(
        ({ response, success }) => {
          setAllowToSubmit(true);
          if (success) {
            notify(
              ValidationErrorMessages.SUCCESS.CHANGE_PASSWORD,
              ToastType.success
            );
            setIsModalOpen(false);
          } else if (!success) {
            notify(
              ValidationErrorMessages.ERRORS.CHANGE_PASSWORD,
              ToastType.error
            );
          }
        }
      );
    }
  };

  return (
    <div
      className={`dashboard-drawer-main ${
        isDrawerOpen ? "openedDrawer" : "closedDrawer"
      }`}
    >
      <div
        className="close-drawer-with-x-icon"
        onClick={() => setIsDrawerOpen(false)}
      >
        <img src={Addresses.icons.CLOSE_MODAL_X} />
      </div>
      <div className="drawer-items-parent">
        <img
          className="profile-picture"
          src={baseURL+userStates.profilePicture}
        />
        <p className="profile-name">{userStates.name}</p>
        <p className="profile-position">{userStates.role}</p>
        <div className="drawer-items-parent">
          {DashboardMenu.map((item, key) =>
            urlPathname === "/" + item.link ||
            urlPathname === item.link ||
            urlPathname === item.link + "/" ||
            urlPathname === "/" + item.link + "/" ? (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items current-page">
                  <img src={item.activeIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            ) : item.link === URL_Route.Log_Out ? (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items exit-profile">
                  <img src={item.defaultIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            ) : item.link === URL_Route.Change_Password ? (
              <div
                key={key}
                onClick={() => setIsModalOpen(true)}
                className="drawer-menu-items"
              >
                <img src={item.defaultIcon} />
                <p>{item.text}</p>
              </div>
            ) : (
              <Link key={key} to={item.link}>
                <div className="drawer-menu-items">
                  <img src={item.defaultIcon} />
                  <p>{item.text}</p>
                </div>
              </Link>
            )
          )}
        </div>
      </div>
      <CustomModal
        showModal={isModalOpen}
        close={() => setIsModalOpen(false)}
        closeAble={true}
        maxWidth={"90%"}
      >
        <div className="reset-password-modal-parent">
          <p>{SiteText.GENERAL.CHANGE_PASSWORD}</p>
          <form onSubmit={ChangePassword}>
            <div className="input-parent">
              <TextInput
                lable={Labels.InputLabels.oldPassword}
                value={oldPassword}
                className={"login-input"}
                error={error.oldPasswordError}
                autoFocus={true}
                regex={""}
                required={true}
                type={"password"}
                name={"current-password"}
                onChangeValue={setOldPassword}
                removeLable={false}
                placeholder={""}
              />
            </div>
            <div className="input-parent">
              <TextInput
                lable={Labels.InputLabels.newPassword}
                value={newPassword}
                className={"login-input"}
                error={error.newPasswordError}
                autoFocus={false}
                regex={""}
                required={true}
                type={"password"}
                name={"new-password"}
                onChangeValue={setNewPassword}
                removeLable={false}
                placeholder={""}
              />
            </div>
            <div className="input-parent">
              <TextInput
                lable={Labels.InputLabels.confirmPassword}
                value={repeatNewPassword}
                className={"login-input"}
                error={error.confirmPasswordError}
                autoFocus={false}
                regex={""}
                required={true}
                type={"password"}
                name={"repeate-new-password"}
                onChangeValue={setRepeatNewPassword}
                removeLable={false}
                placeholder={""}
              />
            </div>
            <button onSubmit={ChangePassword} className="btn">
              {Labels.ButtonLabels.SUBMIT}
            </button>
          </form>
        </div>
      </CustomModal>
    </div>
  );
};

export default SideMenuMobile;
